<template>
  <transition name="fadePopup">
    <div class="popup news-popup" v-if="currentArticleIndex !== '' && popupOpened">
      <div class="popup__content light-bg" v-bar="{preventParentScroll: true}">
        <div class="article-full" ref="articleFull">
          <transition name="fadePopup">
            <div class="article-full__content">
              <h2>{{currArr.text.item.title}}</h2>
              <div class="article-full__date">
                {{setDay(currArr.publication_datetime.$day)}}
                {{$t("months")[parseInt(currArr.publication_datetime.$month, 10) - 1]}}
                {{currArr.publication_datetime.$year}}
              </div>
              <div v-html="currArr.text.item.text_content"></div>
            </div>
          </transition>
        </div>
      </div>
      <span class="popup__close" @click="resetCurrentArticle">
        <span class="icon-exit"></span>
      </span>
      <div class="popup__controls">
        <span class="popup__control" :class="{'disabled': currentArticleIndex === 0}" @click="changeCurrentArticle(currentArticleIndex - 1)">
          <span class="icon-arrow-left"></span>
        </span>
        <span class="popup__control" :class="{'disabled': currentArticleIndex === news.item.length - 1}" @click="changeCurrentArticle(currentArticleIndex + 1)">
          <span class="icon-arrow-right"></span>
        </span>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import prettifyDay from '@/helpers/prettifyDay';

export default {
  name: 'newsList',
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      currentArticleIndex: 'currentArticleIndex',
      news: 'news',
      popupOpened: 'popupOpened',
    }),
    currArr: function newCurrentArticleIndex() {
      return this.news.item[this.currentArticleIndex];
    },
  },
  methods: {
    resetCurrentArticle() {
      this.$store.commit('SET_CURRENT_ARTICLE', '');
      this.$store.commit('SET_POPUP_STATE', false);
    },
    changeCurrentArticle(index) {
      if (index >= 0 && index < this.news.item.length) {
        this.$refs.articleFull.scrollTop = 0;
        this.$store.commit('SET_CURRENT_ARTICLE', index);
      }
    },
    setDay(day) {
      return prettifyDay(day);
    },
  },
  mounted() {
    window.addEventListener('keyup', (event) => {
      if (event.keyCode === 27 && this.currentArticleIndex !== '') {
        this.resetCurrentArticle();
      }
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .fadePopup {
    &-enter,
    &-leave {
      &-active {
        transition: opacity .3s ease;
      }
    }

    &-enter,
    &-leave-to {
      opacity: 0;
    }
  }

  .news-popup {
    background: $lightest-color;
    padding: 85px 70px 70px;
    position: fixed;
    top: 70px;
    left: 50px;
    right: 50px;
    bottom: 70px;
    width: 70%;
    max-width: 1000px;
    z-index: 11;
    margin: auto;
    color: $darkest-color;
  }

  .popup {
    &__controls {
      height: 36px;
      padding: 0;
      position: absolute;
      left: 70px;
      top: 25px;
    }

    &__control {
      margin: 0 30px 0 0;
      cursor: pointer;
      font-size: 36px;

      &:last-child {
        margin-right: 0;
      }

      &.disabled {
        opacity: 0.3;
        cursor: default;
      }

      span {
        position: relative;
        transform: translate3d(0, 0, 0);

        &.icon-arrow-left {
          left: 0;
          transition: left 0.2s ease;
        }

        &.icon-arrow-right {
          right: 0;
          transition: right 0.2s ease;
        }
      }

      &:not(.disabled):hover {
        .icon-arrow-left {
          left: -10px;
        }

        .icon-arrow-right {
          right: -10px;
        }
      }
    }
  }

  .article-full {
    &__date {
      color: rgba(0, 0, 0, 0.6);
      margin-bottom: 30px;
    }

    &__content {
      padding-right: 15px;
      background-color: $lightest-color;
    }
  }

  .vb {
    & > .vb-dragger {
      z-index: 5;
      width: 7px;
      right: 1px;

      &:hover {
        & > .vb-dragger-styler {
          background-color: rgba(0, 0, 0, .5);
        }
      }

      & > .vb-dragger-styler {
        backface-visibility: hidden;
        transform: rotate3d(0,0,0,0);
        transition: background-color 100ms ease-out;
        background-color: rgba(0, 0, 0, .1);
        border-radius: 20px;
        height: 100%;
        display: block;
      }
    }

    &.vb-scrolling-phantom {
      & > .vb-dragger {
        & > .vb-dragger-styler {
          background-color: rgba(0, 0, 0, .3);
        }
      }
    }

    &.vb-dragging {
      & > .vb-dragger {
        & > .vb-dragger-styler {
          background-color: rgba(0, 0, 0, .5);
          margin: 0px;
        }
      }
    }

    &.vb-dragging-phantom {
      & > .vb-dragger {
        & > .vb-dragger-styler {
          background-color: rgba(0, 0, 0, .5);
        }
      }
    }
  }

  @media (max-width: 850px) {
    .news-popup {
      padding: 85px 25px 25px;
      width: 100%;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }

    .popup {
      &__controls {
        left: 25px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/NewsPopup.vue?270d0f4c